import axios from 'axios';
import { API_BASE_URL } from '@/config/mobile_config.js';

const AXIOS = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000,
});

export default {
    activationRequest() {
        return AXIOS.get('/api/view/activation-request');
    },
    activationResponse(request) {
        return AXIOS.post('/api/view/activation-request',request);
    },
    getEnvironment() {
        console.log('axios getEnvironment :');
        return AXIOS.get('/environment');
    },
    getTranslation() {
    	console.log('axios getTranslation :');
    },
    getAllowedChars() {
        console.log('API_BASE_URL : '+API_BASE_URL);
        return AXIOS.get('/allowed-chars');
    },
    getModuleName() {
      console.log('API_BASE_URL : '+API_BASE_URL);
      return AXIOS.get('/module-name');
    },
    loadZipCodes(queryString) {
      return AXIOS.get('/api/zipcodes'+queryString);
     },
    setLanguage(lang) {
      return AXIOS.get('/api/view/setLanguage?lang='+lang); 
    }
};